import React from 'react'
import './style.css'

const ProfBanner = () => {
    return (
        <>
            <div className="prof-banner-box">
                <div className="container h-100">
                    <div className="row h-100">
                        <div className="col-md-12 h-100">
                            <div className="banner-text h-100">
                                <img src="/images/prof-banner-icon.png" className='me-3' width={'70px'} alt="" />
                                <div className="banner-text-icon">
                                    <h1>I-Sit Professional</h1>
                                    <p>Get Start with I-Set Professional User <i className="fas fa-exclamation exclamation-icon"></i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfBanner